import RootStore from '@App/stores/root-store'
import { makeObservable, observable } from 'mobx'
import { getCatalogTransferList, getCatalogTransferReviewList } from '@App/api/routes/rightsholder/catalog-transfer'
import { CatalogTransferView } from '@Entities/rightsholder/catalog-transfer-view'
import { ResultPage } from '@Entities/result-page'
import { PaginationInfo } from '@Entities/pagination'
import CatalogTransferTabStore, {
    CatalogTransferTabScope,
} from '@App/stores/rightsholder/catalogTransfer/catalog-transfer-tab-store'

export interface TransferPageState {
    page?: ResultPage<CatalogTransferView>
    pagination?: PaginationInfo
}

class CatalogTransferListStore {
    private readonly rootStore: RootStore
    private _catalogTransferTabStores: Map<CatalogTransferTabScope, CatalogTransferTabStore>

    constructor(rootStore: RootStore) {
        makeObservable<CatalogTransferListStore, '_catalogTransferTabStores'>(this, {
            _catalogTransferTabStores: observable,
        })
        this.rootStore = rootStore
        this._catalogTransferTabStores = this.getCatalogTransferTabStores()
    }

    get catalogTransferListTabStore(): CatalogTransferTabStore {
        const tabStore = this._catalogTransferTabStores.get('LIST')
        if (tabStore) {
            return tabStore
        }
        const newTabStore = new CatalogTransferTabStore(this.rootStore, getCatalogTransferList, 'LIST')
        this._catalogTransferTabStores.set('LIST', newTabStore)
        return newTabStore
    }

    get catalogTransferReviewTabStore(): CatalogTransferTabStore {
        const tabStore = this._catalogTransferTabStores.get('REVIEW')
        if (tabStore) {
            return tabStore
        }
        const newTabStore = new CatalogTransferTabStore(this.rootStore, getCatalogTransferReviewList, 'REVIEW')
        this._catalogTransferTabStores.set('REVIEW', newTabStore)
        return newTabStore
    }

    invalidateCatalogTransfers(): void {
        this.catalogTransferListTabStore.invalidate()
        this.catalogTransferReviewTabStore.invalidate()
    }

    private getCatalogTransferTabStores(): Map<CatalogTransferTabScope, CatalogTransferTabStore> {
        return new Map<CatalogTransferTabScope, CatalogTransferTabStore>()
            .set('LIST', new CatalogTransferTabStore(this.rootStore, getCatalogTransferList, 'LIST'))
            .set('REVIEW', new CatalogTransferTabStore(this.rootStore, getCatalogTransferReviewList, 'REVIEW'))
    }

    reset(): void {
        this._catalogTransferTabStores = this.getCatalogTransferTabStores()
    }
}

export default CatalogTransferListStore
